import React from 'react'

type Props = {
    className?: string
}

export const ChevronUpIcon = (props: Props) => {
    const { className = "w-5 h-5" } = props
    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <path d="m18 15-6-6-6 6"/>
        </svg>
    )
}
